export default "__VITE_ASSET__BKXN6N9V__"